import React from "react";
import { useQuickSightClaudeCoworkBedrock } from "@/hooks/useClaudeCoworkBedrockReports";

const QuickSightAwsClaudeCoworkBedrockDashboard = () => {
  const { embedUrl } = useQuickSightClaudeCoworkBedrock ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsClaudeCoworkBedrockDashboard;
